var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('link-list',{attrs:{"list":_vm.list,"loading":_vm.loading,"icon":"fa-file-alt"}})}
var staticRenderFns = []

export { render, staticRenderFns }